// Local Imports
import { ROUTE_PATHS } from '@/router/constants';

// Brand Private Routes
export const brandRoutes = [
  {
    path: ROUTE_PATHS.BRANDS,
    moduleName: 'Brands',
    element: <div>Welcome to Brands Dashboard</div>
  }
];

